import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';

import { colors, mq, radii, shadows, spacing } from '@/lib/theme';

type PanelPadding = 'none' | 'sm' | 'md' | 'lg';

const PADDING: Record<PanelPadding, string> = {
	none: '0',
	sm: spacing.space40,
	md: `${spacing.space40}; ${mq.md} { padding: ${spacing.space50}; }`,
	lg: `${spacing.space50}; ${mq.md} { padding: ${spacing.space60}; }`,
};

interface PanelProps {
	/** Inner padding. `md` (default) grows from 16px to 24px at the medium breakpoint. */
	padding?: PanelPadding;
	/** Draw a 1px border instead of a shadow (for panels inside other panels). */
	outlined?: boolean;
}

const shouldForwardProp = (prop: string) =>
	isPropValid(prop) && prop !== 'padding' && prop !== 'outlined';

/**
 * The white card every section of content sits in. Children are laid out by
 * the caller (usually with `Stack`), so the panel itself adds no margins.
 */
export const Panel = styled('section', { shouldForwardProp })<PanelProps>`
	background: ${colors.LM_NU0};
	border-radius: ${radii.radii40};
	${({ outlined }) =>
		outlined
			? `border: 1px solid ${colors.interface.border};`
			: `box-shadow: ${shadows.shadow10};`}
	padding: ${({ padding = 'md' }) => PADDING[padding]};
	min-width: 0;
`;
